import { render, staticRenderFns } from "./welcome-sign-subscription-agreement.vue?vue&type=template&id=04a8a455&scoped=true&"
import script from "./welcome-sign-subscription-agreement.vue?vue&type=script&lang=js&"
export * from "./welcome-sign-subscription-agreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8a455",
  null
  
)

export default component.exports